export function getOutboundInboundCompanyAndRouteParams(
  outbound: TransportBoundType | undefined,
  inbound: TransportBoundType | undefined
): {
  outboundAirlineId: string;
  inboundAirlineId: string;
  outboundRouteId: string;
  inboundRouteId: string;
} {
  return {
    outboundAirlineId: outbound?.segments.map((segment) => segment.company.code).join('#') || '',
    inboundAirlineId: inbound?.segments.map((segment) => segment.company.code).join('#') || '',
    outboundRouteId:
      outbound?.segments.map((segment) => `${segment.departureHub.id}-${segment.arrivalHub.id}`).join('#') || '',
    inboundRouteId:
      inbound?.segments.map((segment) => `${segment.departureHub.id}-${segment.arrivalHub.id}`).join('#') || '',
  };
}

export function getTransportCompanyAndRouteParams(transport: TransportsType | undefined): {
  outboundAirlineId: string;
  inboundAirlineId: string;
  outboundRouteId: string;
  inboundRouteId: string;
} {
  return getOutboundInboundCompanyAndRouteParams(transport?.outbound, transport?.inbound);
}

export function getOutboundInboundIdParams(
  outbound: TransportBoundType | undefined,
  inbound: TransportBoundType | undefined
): {
  inboundFlightId: string;
  outboundFlightId: string;
} {
  return {
    outboundFlightId:
      outbound?.segments.map((segment) => segment.company.code + segment.transportNumber).join('#') || '',
    inboundFlightId: inbound?.segments.map((segment) => segment.company.code + segment.transportNumber).join('#') || '',
  };
}

export function getTransportIdParams(transport: TransportsType | undefined): {
  inboundFlightId: string;
  outboundFlightId: string;
} {
  return getOutboundInboundIdParams(transport?.outbound, transport?.inbound);
}
